import React from 'react';

type WelcomeProps = {
  login: () => void;
  logout: () => void;
  isAuthenticated: boolean;
};

export default function WelcomePage({ login, logout, isAuthenticated }: WelcomeProps) {
  return (
    <div>
      <h1>Welcome to Lab 4: Understanding nOAuth Attacks</h1>
      <p>Learn how email claims can be abused in misconfigured Entra ID applications.</p>
      <button onClick={isAuthenticated ? logout : login}>
        {isAuthenticated ? "Logout" : "Login with Microsoft"}
      </button>
    </div>
  );
}
